import React, { useState } from 'react';

//components
import Stacker from './stacker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faNode,
  faReact,
  faHtml5,
  faAndroid,
  faApple,
  faDocker,
  faAws
} from '@fortawesome/free-brands-svg-icons';
import Slider from 'react-slick';

//hooks
import { useChangeStackValue, useChangeSlideValue } from '../../utils/hooks';

//styles
import * as S from './styles';
import * as A from './../../styles/shared-components';

//icons
import faMobile from '../../icons/mobile.svg';
import faCog from '../../icons/cog.svg';
import faFeather from '../../icons/feather.svg';
import faChecklist from '../../icons/checklist.svg';

function Stack({}) {
  //custom hooks
  const stacked = useChangeStackValue();
  const slides = useChangeSlideValue();

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: slides + 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  };

  return (
    <S.Content>
      <center>
        <h2>Our Services</h2>
      </center>
      <S.ServicesGrid>
        <Stacker
          mainIcon={faMobile}
          title="Mobile Development"
          iconStyle={{ transform: "translate(0px, 0px) scale(1)" }}
          content="SatyaTech develop mobile apps for all contemporary 
mobile platforms.The team builds 
native and cross-platform solutions."
        />
        <Stacker
          mainIcon={faCog}
          title="Web Development"
          iconStyle={{ transform: "translate(3.6px, 2.3px) scale(0.92)" }}
          content="SatyaTech offers various
          CMS and frameworks based websites to complex
          ERP/CRM solutions and e-commerce stores."
        />
        <Stacker
          mainIcon={faFeather}
          title="Product Design"
          iconStyle={{ transform: "translate(4px, 3px) scale(0.82)" }}
          content="We create design given the product audience,
          goal, business domain, technology and
          the platform for the solution."
        />
        <Stacker
          mainIcon={faChecklist}
          title="Quality Assurance"
          iconStyle={{ transform: "translate(0px, 0px) scale(1)" }}
          content="Our QA team ensures high standard of 
          quality of products delivered. We provide continuos support with timely updates.
          "
        />
      </S.ServicesGrid>
      {stacked == 10 && <A.Space huge />}
      {stacked == 6 && <A.Space medium />}
      {stacked == 4 && <A.Space small />}
      {stacked > 4 ? (
        <S.ProgLang>
          <FontAwesomeIcon icon={faHtml5} size="3x" />
          <FontAwesomeIcon icon={faNode} size="3x" />
          <FontAwesomeIcon icon={faReact} size="3x" />
          <FontAwesomeIcon icon={faAndroid} size="3x" />
          <FontAwesomeIcon icon={faApple} size="3x" />
          <FontAwesomeIcon icon={faDocker} size="3x" />
          <FontAwesomeIcon icon={faAws} size="3x" />
        </S.ProgLang>
      ) : (
        <center>
          <S.Slider>
            <Slider {...settings}>
              <FontAwesomeIcon icon={faHtml5} size="3x" />
              <FontAwesomeIcon icon={faNode} size="3x" />
              <FontAwesomeIcon icon={faReact} size="3x" />
              <FontAwesomeIcon icon={faAndroid} size="3x" />
              <FontAwesomeIcon icon={faApple} size="3x" />
              <FontAwesomeIcon icon={faDocker} size="3x" />
              <FontAwesomeIcon icon={faAws} size="3x" />
            </Slider>
          </S.Slider>
        </center>
      )}
    </S.Content>
  );
}

export default Stack;
